module.exports = __webpack_public_path__ + "static/media/sinImagen.1d6ab4ff.jpg";